import { useNavigate, useLocation, Outlet } from 'react-router'
import { useTranslation } from 'react-i18next'
import { Languages } from 'lucide-react'

import { Button } from '@/shared/components/ui/button'
import { StaffShell } from '@/admin/components/staff/staff-shell'
import { cn } from '@/shared/lib/utils'

export function StaffSettingsPage() {
  const navigate = useNavigate()
  const location = useLocation()
  const { t } = useTranslation()

  const sidebarItems = [
    { label: t('staffSettings.translations'), path: '/staff/settings/translations', icon: Languages },
  ]

  return (
    <StaffShell>
      <div className="flex min-h-[calc(100vh-56px)]">
        <aside className="w-56 shrink-0 border-r-[0.5px] border-r-[var(--rule)] px-4 py-8">
          <h1 className="clara-title px-3 mb-6">{t('nav.settings')}</h1>
          <nav className="flex flex-col gap-0.5">
            {sidebarItems.map((item) => {
              const isActive = location.pathname.startsWith(item.path)
              const Icon = item.icon
              return (
                <Button
                  variant="ghost"
                  key={item.path}
                  onClick={() => navigate(item.path)}
                  className={cn(
                    'flex w-full items-center gap-2.5 rounded-[4px] px-3 py-2 text-left text-[12px] transition-all duration-150',
                    isActive
                      ? 'bg-[var(--green-bg-subtle)] text-[var(--green)]'
                      : 'bg-transparent text-[var(--ink-2)] hover:bg-[var(--bg-subtle)]',
                  )}
                >
                  <Icon className="h-3.5 w-3.5" />
                  {item.label}
                </Button>
              )
            })}
          </nav>
        </aside>

        <div className="flex-1 py-8 px-8">
          <Outlet />
        </div>
      </div>
    </StaffShell>
  )
}
